@if (isError && !isLoading) {
  <div class="h-[80%]">
    <app-something-went-wrong
      description="{{ 'cannotLoadTags' | translate }}"
      [showPicture]="false"
      (retryEmitter)="retryData()"></app-something-went-wrong>
  </div>
}

@if (!isError) {
  <div class="flex-col-container-1">
    <div class="search-panel">
      <div class="button-group">
        <button
          mat-raised-button
          color="primary"
          class="page-block-button"
          aria-label="Add tag"
          (click)="openCreateModelForm()">
          <mat-icon class="{{ useMobileView ? '!m-0' : '' }}">add</mat-icon>
          {{ useMobileView ? '' : ('newTag' | translate) }}
        </button>
        @if (isExporting) {
          <div class="w-[2.5rem]">
            <app-loader
              padding="0"
              [diameter]="'22'"
              height="100%"></app-loader>
          </div>
        } @else {
          <button
            mat-icon-button
            [attr.aria-label]="'exportExcel' | translate"
            (click)="exportExcel()"
            matTooltip="{{ 'exportExcel' | translate }}">
            <i class="far fa-file-excel fa-xs"></i>
          </button>
        }
      </div>
      <div class="search-bar">
        <app-search-bar
          [fullWidth]="useMobileView"
          (searchEventEmitter)="onSearch()"
          (valueChangedEventEmitter)="onSearchValueChanged($event)"
          [search]="searchValue"></app-search-bar>
        @if (!useMobileView) {
          <app-table-header
            [countTotal]="totalSize"
            (reloadEventEmitter)="reload()"
            [isReloadLoading]="isReloadLoading"></app-table-header>
        }
      </div>
    </div>
  </div>
}
@if (useMobileView) {
  <app-table-header
    [countTotal]="totalSize"
    (reloadEventEmitter)="reload()"
    (searchOrderChangeEventEmitter)="searchOrderChange($event)"
    (changeOrderEventEmitter)="changeOrder()"
    [searchOrder]="searchOrder"
    [searchOrders]="searchOrders"
    [orderDirection]="filter.orderDirection"
    [isReloadLoading]="isReloadLoading"></app-table-header>
  @if (!isLoading && !isError) {
    <div class="h-full">
      <app-infinity-scroll
        [isErrorScroll]="isErrorScroll"
        [isLoadingScroll]="isLoadingScroll"
        [canNavigateForward]="canNavigateForward"
        [dataLength]="dataSource.data.length"
        (loadData)="onScroll()"
        (refreshData)="refreshData()">
        <div class="mobile-container-cards">
          @for (tag of dataSource.data; track tag.tag) {
            <div class="card">
              <mat-card class="mobile-row">
                <mat-card-content class="flex flex-1">
                  <div class="card-table-row items-center">
                    <div class="card-table-row-value">
                      <app-tag-component [tag]="tag" />
                    </div>
                  </div>
                </mat-card-content>
                <div class="icons-mobile-block">
                  <ng-container
                    *ngTemplateOutlet="
                      actionsTemplate;
                      context: { $implicit: tag }
                    "></ng-container>
                </div>
              </mat-card>
            </div>
          }
        </div>
        @if (!dataSource.data.length) {
          <app-no-data></app-no-data>
        }
      </app-infinity-scroll>
    </div>
  }
}

@if (!useMobileView && !isLoading && !isError) {
  <div class="settings-table-container h-full">
    <app-infinity-scroll
      [isErrorScroll]="isErrorScroll"
      [isLoadingScroll]="isLoadingScroll"
      [canNavigateForward]="canNavigateForward"
      [dataLength]="dataSource.data.length"
      (loadData)="onScroll()"
      (refreshData)="refreshData()">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        (matSortChange)="sortData($event)">
        <ng-container matColumnDef="tag">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'tagLabel' | translate }}
          </th>
          <td mat-cell *matCellDef="let tag">
            <app-tag-component [tag]="tag" />
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'actions' | translate }}</th>
          <td mat-cell *matCellDef="let tag">
            <ng-container
              *ngTemplateOutlet="
                actionsTemplate;
                context: { $implicit: tag }
              "></ng-container>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="cursor-default"></tr>
      </table>
      @if (!dataSource.data.length) {
        <app-no-data></app-no-data>
      }
    </app-infinity-scroll>
  </div>
}

@if (isLoading) {
  <div class="flex-1 overflow-hidden">
    <app-skeleton-table></app-skeleton-table>
  </div>
}

<ng-template #addDrawer>
  <app-mail-account-tag-create-dialog
    (closeEventEmitter)="onCloseEditModalForm()"
    (submitEventEmitter)="onCreateTag()"
    [editingTag]="editingTag"
    [mailAccountId]="mailAccountId">
  </app-mail-account-tag-create-dialog>
</ng-template>

<ng-template #actionsTemplate let-tag>
  <button
    mat-icon-button
    aria-label="Modify"
    matTooltip="{{ 'modify' | translate }}"
    (click)="editTag(tag)">
    <mat-icon>edit_outline</mat-icon>
  </button>
  <button
    mat-icon-button
    matTooltip="{{ 'delete' | translate }}"
    color="primary"
    aria-label="Delete"
    (click)="deleteTag(tag.tagId, tag.tag)">
    <mat-icon>delete_outline</mat-icon>
  </button>
</ng-template>
